<template>
    <component :is="component" v-if="component"></component>
</template>

<script>
export default {
    name: "PortfolioWriteLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        writeLayout: '',
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/portfolio/write/PortfolioWriteDefaultLayout')
                })
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.writeLayout) {
                return null
            }
            return () => import(`@/template/portfolio/write/${this.writeLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>